module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[61]548.6cb0930.woff2";